
    import { useRoute } from "vue-router";
    import { computed } from "vue";
    import Navigation from "@/components/AppNavigation.vue";
    import Socials from "@/components/AppSocials.vue";
    import { profile, socials } from "@/data";

    export default {
        components: { Socials, Navigation },
        setup() {
            const route = useRoute();
            const pathName = computed(() =>
                route.path.replace(/[\\/]/gi, "").toLowerCase()
            );

            return { pathName, profile, socials };
        },
    };
